import {createContext} from "react";
import {IAdTagResponce} from "@pages/Root/services/api/ads/interfaces.ts";

export interface IAdConfigContext {
    hideAdSlotIds: string[],
    adUnitIndex: number,
    updateAdUnitIndex: (index: number) => void,
    adConfigData?: IAdTagResponce,
    updateAdConfigData: (adConfigData: IAdTagResponce) => void,
}

export const AdConfigContext = createContext<IAdConfigContext>({
        hideAdSlotIds: [],
        adUnitIndex: 0,
        updateAdUnitIndex: (index: number) => {},
        adConfigData: undefined,
        updateAdConfigData: (adConfigData: IAdTagResponce) => {},
    }
);
